var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Buy_icon",
    "data-name": "Buy icon",
    transform: "translate(0.68 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buy_icon-2",
    "data-name": "buy icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_32x32",
    "data-name": "32x32",
    width: 32,
    height: 32,
    transform: "translate(-0.68 -2)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(-0.68 -2)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "dollar_icon",
    "data-name": "dollar icon",
    d: "M12.78,11.778c-2.676-.656-3.536-1.333-3.536-2.389,0-1.211,1.191-2.056,3.183-2.056,2.1,0,2.876.944,2.947,2.333h2.605a4.505,4.505,0,0,0-3.784-4.233V3H10.658V5.4c-2.287.467-4.126,1.867-4.126,4.011,0,2.567,2.251,3.844,5.54,4.589,2.947.667,3.536,1.644,3.536,2.678,0,.767-.578,1.989-3.183,1.989-2.428,0-3.383-1.022-3.513-2.333H6.32c.141,2.433,2.075,3.8,4.338,4.256V23h3.536V20.611c2.3-.411,4.126-1.667,4.126-3.944C18.32,13.511,15.456,12.433,12.78,11.778Z",
    transform: "translate(3 1)",
    fill: "gray"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyIcon);
export default __webpack_public_path__ + "static/media/BuyIcon.5960b0a1cb43f0e7b2660cc66c1d421b.svg";
export { ForwardRef as ReactComponent };